import {useState, useEffect} from "react";
import {useParams} from "react-router-dom";
import baseUrl from "../../baseUrl";
import {requester} from "../../services/requester";
import {downloadPdf} from "../../services/downloadPdf";

// С7 — ДЗ между двама ползватели, по села + равнение (Г3 §4).
// Остава на URL /reports/s4/... (клиентският рут не се пипа).
export const ReportS4 = () => {
    const {year, bullstat1, bullstat2} = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const request = requester();

    useEffect(() => {
        request.get(`${baseUrl()}/reports/s4/${year}/${bullstat1}/${bullstat2}`)
            .then(res => {
                setData(res);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [year, bullstat1, bullstat2]);

    const handlePdf = () => {
        downloadPdf(`/reports/s4/${year}/${bullstat1}/${bullstat2}?format=pdf`, `S7_${bullstat1}_${bullstat2}_${year}.pdf`);
    };

    if (loading) return <div className="mt-3">Зареждане...</div>;
    if (!data) return <div className="mt-3 alert alert-warning">Няма данни.</div>;

    const c1 = data.company1;
    const c2 = data.company2;
    // Ц3: равнението е върху ВСИЧКО (по села + неопределено), не върху ОБЩО по
    // села. Замяната се вписва с едно конкретно землище и огледално в
    // „неопределено"; от коя страна е въведена, решава в коя колона ще застане
    // именуваното землище. Затова разликата ПО СЕЛА не е нула и при съвършено
    // изрядни данни (реален пример: 2150.44 срещу 1258.83) — и не бива да пали
    // предупреждение. Дали е равнено, решава СЪРВЪРЪТ по незакръглените сборове.
    const allDiff = data.difference_all ?? data.difference;
    const balanced = data.balanced ?? (Math.abs(allDiff) < 0.005);
    const mirrored = data.mirrored ?? (Math.abs((data.diff_company1_gives ?? 0)
        + (data.diff_company2_gives ?? 0)) < 0.02);
    // Равнено е, но показаното число не е нула — значи е само закръгляне.
    const отЗакръгляне = balanced && Math.abs(allDiff) >= 0.005;
    const fmt = v => Number(v ?? 0).toFixed(2);

    return (
        <div className="mt-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h5 style={{color: "var(--app-gold)"}}>С7 — ДЗ между двама ползватели</h5>
                    <div>1: {c1.company_name}, Булстат: {c1.bullstat}</div>
                    <div>2: {c2.company_name}, Булстат: {c2.bullstat}</div>
                    <div>Стопанска {data.year} година | {data.date}</div>
                </div>
                <button className="btn btn-outline-danger" onClick={handlePdf}>PDF</button>
            </div>

            {data.villages.length === 0 && (
                <div className="alert alert-info">Няма замени между тези двама ползватели.</div>
            )}

            {data.villages.length > 0 && (
                <div className="table-responsive">
                    <table className="table table-sm table-bordered">
                        <thead className="tableHead">
                        <tr>
                            <th>Село</th>
                            <th className="text-end">1 дава (дка)</th>
                            <th className="text-end">2 дава (дка)</th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.villages.map((v, i) => (
                            <tr key={i}>
                                <td>{v.settlement_name}</td>
                                <td className="text-end">{v.company1_gives.toFixed(2)}</td>
                                <td className="text-end">{v.company2_gives.toFixed(2)}</td>
                            </tr>
                        ))}
                        </tbody>
                        <tfoot>
                        {/* Ц3: ОБЩО е САМО по села. Неопределеното е огледалният
                            запис на същите замени — събрано с тях, всяка замяна
                            влизаше по два пъти. Стои на свой ред отдолу. */}
                        <tr className="fw-bold">
                            <td>ОБЩО по села</td>
                            <td className="text-end">{fmt(data.total_company1_gives)}</td>
                            <td className="text-end">{fmt(data.total_company2_gives)}</td>
                        </tr>
                        {(data.undetermined_company1_gives !== undefined) &&
                         (data.undetermined_company1_gives !== 0 || data.undetermined_company2_gives !== 0) && (
                            <>
                                <tr className="text-muted">
                                    <td>Неопределено (извън общото)</td>
                                    <td className="text-end">{fmt(data.undetermined_company1_gives)}</td>
                                    <td className="text-end">{fmt(data.undetermined_company2_gives)}</td>
                                </tr>
                                {/* Ц3: тук двете колони трябва да излязат равни —
                                    това е истинската контрола за равни рамене. */}
                                <tr className="text-muted">
                                    <td>Всичко (по села + неопределено)</td>
                                    <td className="text-end">{fmt(data.all_company1_gives)}</td>
                                    <td className="text-end">{fmt(data.all_company2_gives)}</td>
                                </tr>
                            </>
                        )}
                        {/* Р3: неопределеното минус сбора на именуваните землища.
                            Когато всичко е отразено вярно, двете числа излизат
                            еднакви по големина и с обратен знак — това е самата
                            контрола, затова се смятат независимо. */}
                        <tr className="fw-bold">
                            <td>
                                Общо разлики
                                <span className="fw-normal text-muted"
                                      style={{fontSize: "0.85rem"}}>
                                    {" "}(неопределено − землищата)
                                </span>
                            </td>
                            <td className="text-end">{fmt(data.diff_company1_gives)}</td>
                            <td className="text-end">{fmt(data.diff_company2_gives)}</td>
                        </tr>
                        </tfoot>
                    </table>
                </div>
            )}

            <div className="fw-bold mt-3" style={{fontSize: "1.1em"}}>
                Разлика по села (1 дава − 2 дава): {fmt(data.difference)}
            </div>
            <div className="text-muted" style={{fontSize: "0.9rem"}}>
                Тази разлика НЕ е грешка, когато не е нула: замяната се вписва с едно
                конкретно землище, а насрещното остава „неопределено“, и от коя страна
                е въведена, решава в коя колона ще застане именуваното землище.
            </div>
            {/* Ц3: контролата за равни рамене е върху ВСИЧКО, не по села. */}
            <div className={`fw-bold mt-2 ${balanced ? '' : 'text-danger'}`}>
                Равнение (всичко): {fmt(data.all_company1_gives)} срещу{" "}
                {fmt(data.all_company2_gives)}
                {balanced
                    ? (отЗакръгляне ? ' ✓ (равнени — остатъкът е от закръгляне)'
                                    : ' ✓ (равнени)')
                    : ' ⚠ (неконсистентни данни)'}
            </div>
            {/* Р3: втората контрола — двете „Общо разлики" трябва да са огледални. */}
            {(data.diff_company1_gives !== undefined) && (
                <div className={`mt-2 ${mirrored ? 'text-muted' : 'fw-bold text-danger'}`}
                     style={{fontSize: "0.9rem"}}>
                    {mirrored
                        ? "„Общо разлики“ на двете колони са огледални — замените стоят "
                          + "в землищата, в които са отразени."
                        : "⚠ „Общо разлики“ на двете колони НЕ са огледални — възможно е "
                          + "замяна да е приравнена към работното село."}
                </div>
            )}
        </div>
    );
};
